var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.1366 8.1817H0.909362C0.407234 8.1817 0 8.58894 0 9.09106V19.0911C0 19.5928 0.407234 20 0.909362 20H3.1366C3.63872 20 4.04553 19.5928 4.04553 19.0911V9.09106C4.04553 8.58894 3.63872 8.1817 3.1366 8.1817Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45489 10.9085H6.22766C5.72511 10.9085 5.3183 11.3157 5.3183 11.8179V19.0902C5.3183 19.5928 5.72511 19.9996 6.22766 19.9996H8.45489C8.95702 19.9996 9.36383 19.5923 9.36383 19.0902V11.8179C9.36383 11.3157 8.95702 10.9085 8.45489 10.9085Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7723 10.9085H11.5451C11.043 10.9085 10.6362 11.3157 10.6362 11.8179V19.0902C10.6362 19.5928 11.043 19.9996 11.5451 19.9996H13.7723C14.2749 19.9996 14.6817 19.5923 14.6817 19.0902V11.8179C14.6817 11.3157 14.2749 10.9085 13.7723 10.9085Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0906 8.1817H16.8634C16.3613 8.1817 15.9545 8.58894 15.9545 9.09106V19.0911C15.9545 19.5932 16.3613 20 16.8634 20H19.0906C19.5928 20 20 19.5923 20 19.0911V9.09106C20 8.58894 19.5928 8.1817 19.0906 8.1817Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2651 5.47659V7.11319C10.7604 7.08042 11.2826 6.84808 11.2826 6.30298C11.2826 5.74042 10.7102 5.57574 10.2651 5.47659Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.84171 3.51787C8.84171 3.93149 9.14936 4.17064 9.76936 4.29489V2.81447C9.20596 2.83106 8.84171 3.16213 8.84171 3.51787Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0C7.24298 0 5 2.2434 5 5C5 7.75575 7.24298 9.99915 10 9.99915C12.757 9.99915 15 7.75575 15 5C15 2.2434 12.757 0 10 0ZM10.2651 7.95702V8.46894C10.2651 8.60979 10.157 8.75021 10.0157 8.75021C9.87617 8.75021 9.76936 8.60979 9.76936 8.46894V7.95702C8.37234 7.92298 7.67745 7.08809 7.67745 6.43489C7.67745 6.10511 7.87702 5.91447 8.18936 5.91447C9.11532 5.91447 8.39532 7.05532 9.76936 7.11277V5.38511C8.54383 5.16255 7.8017 4.62511 7.8017 3.70766C7.8017 2.58383 8.73617 2.00426 9.76936 1.97192V1.53106C9.76936 1.39021 9.87617 1.24979 10.0157 1.24979C10.157 1.24979 10.2651 1.39021 10.2651 1.53106V1.97192C10.9094 1.98894 12.2323 2.39319 12.2323 3.20383C12.2323 3.52596 11.9915 3.71575 11.7102 3.71575C11.1723 3.71575 11.18 2.83192 10.2651 2.81489V4.38553C11.3562 4.61745 12.3226 4.93958 12.3226 6.21277C12.3226 7.32 11.4962 7.8817 10.2651 7.95702Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormsIcon);
export default __webpack_public_path__ + "static/media/forms-icon.00c984727357b088ee1aab0c89e59b96.svg";
export { ForwardRef as ReactComponent };